import { SVGProps } from 'react'

interface EditorChoiceIconProps extends SVGProps<SVGSVGElement> {}

export function EditorChoiceIcon(props: EditorChoiceIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M240-40v-329L110-580l185-300h370l185 300-130 211v329l-240-80-240 80zm80-111l160-53 160 53v-129H320v129zm20-649L204-580l136 220h280l136-220-136-220H340zm98 383L296-558l57-57 85 85 169-170 57 56-226 227zM320-280h320-320z" />
    </svg>
  )
}
